<div
  clientSideOnly
  *ngIf="isEnabled"
  class="full-loader fixed inset-0 h-screen w-screen bg-[#fcfcfd] z-[999999999999999999] flex flex-col justify-center items-center"
  [class.animate-close]="fireCloseAnimation"
  [class.startImediate]="startImediate"
>
  <img *ngIf="pageType == 'woqod'" src="assets/images/default-img.gif" class="w-64 h-64" />
  <img *ngIf="pageType == 'fahes'" src="assets/images/Fahes_loader_new.gif" class="w-64 h-64" />
  <img *ngIf="pageType == 'qjet'" src="assets/images/Qjet_loader_new.gif" class="w-64 h-64" />  
  <p *ngIf="msg">{{ msg }}</p>
</div>
